module.exports = require("./ar-SA.d.ts");